import EmailVerification from "../../../pages/EmailVerification";

const LmsVerifyEmailPage = () => <EmailVerification />;

export default LmsVerifyEmailPage;
